import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

function makeClient(tokenKey) {
  const client = axios.create({ baseURL: BASE_URL });

  client.interceptors.request.use((config) => {
    const token = localStorage.getItem(tokenKey);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  client.interceptors.response.use(
    (res) => res,
    (err) => {
      const message =
        err?.response?.data?.message || "Something went wrong. Please try again.";
      return Promise.reject({ ...err, friendlyMessage: message });
    }
  );

  return client;
}

// Admin console (existing behaviour, unchanged token key)
const api = makeClient("pm_token");

// Student portal — separate token so a student session can never touch admin routes
export const studentApi = makeClient("pm_student_token");

// Interview panel portal — separate token again
export const panelApi = makeClient("pm_panel_token");

export const FILE_BASE_URL =
  process.env.REACT_APP_FILE_BASE_URL || "http://localhost:5000/uploads";

export default api;
